import React from 'react'
import Header1 from '../components/Header1'
import Footer from '../components/Footer'
import SolutionSection from '../components/SolutionSection'

export default function ProPlusIntelligenceDataSuite() {
  return (
    <div>
      <Header1/>
      <SolutionSection/>
      <Footer/>
    </div>
  )
}
